import QuestionsAndAnswers from './QuestionsAndAnswers'

export default QuestionsAndAnswers
